import React from "react";
import CourseProgramCards from "../../Home/CourseProgramCards";

const ComputerEngineeringPrograms = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Digital Electronics",
    introduction: "Learn digital circuit design and electronic components.",
    buttonText: "LEARN MORE",
    route: "digital-electronics",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Computer Architecture",
    introduction: "Understand computer hardware design and organization.",
    buttonText: "LEARN MORE",
    route: "computer-architecture",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Embedded Systems",
    introduction: "Design and program embedded computer systems.",
    buttonText: "LEARN MORE",
    route: "embedded-systems",
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=2072&q=80",
    heading: "Microprocessors",
    introduction: "Learn microprocessor design and programming.",
    buttonText: "LEARN MORE",
    route: "microprocessors",
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=2072&q=80",
    heading: "VLSI Design",
    introduction: "Design very large scale integrated circuits.",
    buttonText: "LEARN MORE",
    route: "vlsi-design",
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=2072&q=80",
    heading: "Hardware Programming",
    introduction: "Program hardware using HDL and firmware development.",
    buttonText: "LEARN MORE",
    route: "hardware-programming",
  },
];

const ComputerEngineeringProgramsCard = () => {
  return (
    <div className="flex justify-center space-x-0">
      <CourseProgramCards
        programs={ComputerEngineeringPrograms}
        basePath="/courses/computer-engineering"
      />
    </div>
  );
};

export default ComputerEngineeringProgramsCard;
